module.exports = __webpack_public_path__ + "media/src/images/icon/modelhouse-73950c9abb9a4dc9afee6582a52e3da7.png";